export const gridSxProps = theme => ({
  '& .MuiDataGrid-row.product-row .MuiDataGrid-cell[data-field="__check__"] .MuiCheckbox-root svg': {
    borderColor: theme.palette.text.disabled,
  },
  '& .MuiDataGrid-row.product-row .MuiDataGrid-cellCheckbox': {
    '--disabled-checkbox-background': theme.palette.background.defaultdim,
  },
  // Pinned colors as CSS vars
  '--pinned-base': theme.palette.background.input, // base bg for pinned area
  '--pinned-hover': theme.palette.background.section, // hover bg for pinned rows

  // 1) Pin container: set base + override MUI's row hover var locally
  '& .MuiDataGrid-pinnedRows--top': {
    backgroundColor: 'var(--pinned-base)',
    '--DataGrid-rowHoverBackground': 'var(--pinned-hover)',
  },

  // 2) Pinned rows: set base + transition
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row': {
    backgroundColor: 'var(--pinned-base)',
    transition: 'background-color 180ms ease',
  },

  // 3) Pinned row hover: single source of truth (beats any “inherit”)
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row:hover, \
     & .MuiDataGrid-pinnedRows--top .MuiDataGrid-row.Mui-hovered': {
    backgroundColor: 'var(--pinned-hover) !important',
  },

  // 4) Selected + hover in pinned area (avoid second color)
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row.Mui-selected, \
     & .MuiDataGrid-pinnedRows--top .MuiDataGrid-row.Mui-selected:hover': {
    backgroundColor: 'var(--pinned-hover) !important',
  },

  // 5) Cells shouldn’t paint over the row bg
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row:hover .MuiDataGrid-cell': {
    backgroundColor: 'transparent !important',
  },

  // 6) Disable the cell hover transform in pinned area to prevent flicker
  '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-cell:hover': {
    transform: 'none !important',
    boxShadow: 'none !important',
  },

  // A11y: reduce motion
  '@media (prefers-reduced-motion: reduce)': {
    '& .MuiDataGrid-pinnedRows--top .MuiDataGrid-row': {
      transition: 'none',
    },
  },
  '& .MuiDataGrid-filler--pinnedLeft': {
    width: '0px !important',
    display: 'none !important',
  },
})
